/*
 * @Author: your name
 * @Date: 2019-12-06 09:29:16
 * @LastEditTime : 2020-01-14 09:15:54
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \idphotod:\y\ytea\src\utils\utils.js
 */
class utils {
    // 深度克隆
    cloneDeep(target) {
        if (typeof target !== "object") { return target };
        let newTarget = target instanceof Array ? [] : {};
        for (const key in target) {
            if (target.hasOwnProperty(key)) {
                newTarget[key] = utilsInit.cloneDeep(target[key]);
            }
        }
        return newTarget;
    }
    // 防抖函数
    debounce(fn, time = 500, options = { leading: true, context: null }) {
        let timer
        const _debounce = (...args) => {
            if (timer) {
                clearTimeout(timer)
            }
            if (options.leading && !time) {
                timer = setTimeout(null, time)
                fn.apply(options.context, args)
            } else {
                timer = setTimeout(() => {
                    fn.apply(options.context, args)
                    timer = null
                }, time)
            }
        }
        _debounce.cancel = () => {
            clearTimeout(timer)
            timer = null
        }
        return _debounce
    }

}
let utilsInit = new utils();
module.exports = utilsInit